import PropTypes from "prop-types";

export default PropTypes.shape({
  salaryMin: PropTypes.number,
  contractDuration: PropTypes.number,
  contractDurationInterval: PropTypes.string,
  currencySymbol: PropTypes.string.isRequired,
});
